export const BREATHING_TECHNIQUES = [
  // Foundational
  {
    id: 'box',
    name: 'Box Breathing',
    description: 'Navy SEAL technique for calm focus. Equal phases create balance.',
    category: 'Foundational',
    duration: '3-5 min',
    bestFor: ['Stress', 'Focus', 'Anxiety'],
    inhale: 4,
    hold1: 4,
    exhale: 4,
    hold2: 4,
    icon: '⬜',
    color: '#4D96FF',
  },
  {
    id: '478',
    name: '4-7-8 Breathing',
    description: 'Dr. Weil\'s relaxation breath. Slows heart rate naturally.',
    category: 'Foundational',
    duration: '2-3 min',
    bestFor: ['Sleep', 'Anxiety', 'Relaxation'],
    inhale: 4,
    hold1: 7,
    exhale: 8,
    icon: '🌙',
    color: '#9B59B6',
  },
  {
    id: 'diaphragmatic',
    name: 'Diaphragmatic Breathing',
    description: 'Deep belly breathing activates parasympathetic response.',
    category: 'Foundational',
    duration: '5-10 min',
    bestFor: ['Stress Relief', 'Grounding', 'Calm'],
    inhale: 4,
    exhale: 6,
    icon: '🫁',
    color: '#27AE60',
  },
  {
    id: 'equal',
    name: 'Equal Breathing',
    description: 'Sama Vritti. Balance inhale and exhale for equilibrium.',
    category: 'Foundational',
    duration: '3-5 min',
    bestFor: ['Balance', 'Meditation', 'Focus'],
    inhale: 4,
    exhale: 4,
    icon: '⚖️',
    color: '#3498DB',
  },
  {
    id: 'resonance',
    name: 'Resonance Breathing',
    description: '5-6 breaths per minute. Optimal for heart rate variability.',
    category: 'Foundational',
    duration: '5-10 min',
    bestFor: ['Heart Health', 'Calm', 'Performance'],
    inhale: 5,
    exhale: 5,
    icon: '💓',
    color: '#E91E63',
  },
  // Calming & Anti-Anxiety
  {
    id: 'triangle',
    name: 'Triangle Breathing',
    description: 'Three-phase breath for gentle calming.',
    category: 'Calming',
    duration: '3-5 min',
    bestFor: ['Mild Anxiety', 'Transitions', 'Centering'],
    inhale: 4,
    hold1: 4,
    exhale: 4,
    icon: '🔺',
    color: '#FF6B6B',
  },
  {
    id: 'extended-exhale',
    name: 'Extended Exhale',
    description: 'Longer exhale activates vagus nerve for deep calm.',
    category: 'Calming',
    duration: '3-5 min',
    bestFor: ['Anxiety', 'Racing Heart', 'Panic Prevention'],
    inhale: 4,
    exhale: 8,
    icon: '🍃',
    color: '#2ECC71',
  },
  {
    id: 'infinity',
    name: 'Infinity Breath',
    description: 'Visualize figure-8 pattern. Continuous flowing breath.',
    category: 'Calming',
    duration: '3-5 min',
    bestFor: ['Meditation', 'Flow State', 'Gentle Calm'],
    inhale: 4,
    exhale: 4,
    icon: '♾️',
    color: '#00BCD4',
  },
  // Panic Reset
  {
    id: 'physiological-sigh',
    name: 'Physiological Sigh',
    description: 'Double inhale + long exhale. Fastest stress relief.',
    category: 'Panic Reset',
    duration: '1-2 min',
    bestFor: ['Panic', 'Acute Stress', 'Quick Reset'],
    inhale: 2,
    hold1: 1,
    exhale: 6,
    icon: '😮‍💨',
    color: '#E74C3C',
  },
  {
    id: 'micro-breath',
    name: 'Micro-Breath Reset',
    description: 'Tiny sips of breath. Prevents hyperventilation.',
    category: 'Panic Reset',
    duration: '1-2 min',
    bestFor: ['Panic Attack', 'Hyperventilation', 'Emergency'],
    inhale: 2,
    exhale: 4,
    icon: '🆘',
    color: '#C0392B',
  },
  // Sleep & Recovery
  {
    id: 'sleep-wave',
    name: 'Sleep Wave Breath',
    description: 'Gentle ocean-like rhythm to drift into sleep.',
    category: 'Sleep',
    duration: '5-10 min',
    bestFor: ['Insomnia', 'Bedtime', 'Relaxation'],
    inhale: 4,
    hold1: 2,
    exhale: 8,
    icon: '😴',
    color: '#34495E',
  },
  {
    id: 'feather',
    name: 'Feather Float Breath',
    description: 'Imagine exhale floating a feather. Ultra-gentle.',
    category: 'Sleep',
    duration: '5-10 min',
    bestFor: ['Deep Relaxation', 'Children', 'Gentle Sleep'],
    inhale: 3,
    exhale: 6,
    icon: '🪶',
    color: '#607D8B',
  },
  // Focus & Energy
  {
    id: 'breath-ladder',
    name: 'Breath Ladder',
    description: 'Increase counts progressively: 2-2, 3-3, 4-4, etc.',
    category: 'Focus',
    duration: '5-10 min',
    bestFor: ['Focus Building', 'Concentration', 'Challenge'],
    inhale: 4,
    exhale: 4,
    icon: '🪜',
    color: '#FF9800',
  },
  {
    id: 'lions',
    name: 'Lion\'s Breath',
    description: 'Inhale deep, exhale with tongue out. Releases tension.',
    category: 'Focus',
    duration: '2-3 min',
    bestFor: ['Energy', 'Tension Release', 'Morning'],
    inhale: 4,
    exhale: 4,
    icon: '🦁',
    color: '#FFC107',
  },
];

export const CATEGORIES = [
  { id: 'all', name: 'All', icon: '✨' },
  { id: 'Foundational', name: 'Foundation', icon: '🏛️' },
  { id: 'Calming', name: 'Calming', icon: '🧘' },
  { id: 'Panic Reset', name: 'Panic', icon: '🆘' },
  { id: 'Sleep', name: 'Sleep', icon: '😴' },
  { id: 'Focus', name: 'Focus', icon: '🎯' },
];

